import type { FormatterFactory } from '../types';

export interface JoinOptions {
  separator?: string;
}

export const join: FormatterFactory = (options: JoinOptions = {}) => {
  const separator = options.separator ?? ', ';
  return {
    toText: (value) => {
      if (Array.isArray(value)) {
        return value
          .filter((item) => item != null && item !== '')
          .join(separator);
      }
      return value == null ? '' : String(value);
    },
  };
};
